export function setIsLoading(state, payload) {
  state.isDownloadLoading[payload.type] = payload.value;
}
